import i18n from '@plugins/i18n';
import { createEditor } from '@plugins/tiptap';
import { css as alertCss } from '@plugins/tiptap/extensions/Alert';
import { css as checkboxCss } from '@plugins/tiptap/extensions/Checkbox';
import { css as dynamicValueCss } from '@plugins/tiptap/extensions/DynamicValue';
import { css as inputCss } from '@plugins/tiptap/extensions/Input';

export const tipTapToHtml = (content, css = null) => {
    const defaultCss = `
div.wrapper {
    font-variant: normal;
    text-align: left;
    font-feature-settings: normal;
    font-variant-ligatures: none;
    font-family: sans-serif;
}
div.wrapper h1, div.wrapper h2, div.wrapper h3, div.wrapper h4, div.wrapper h5, div.wrapper h6, div.wrapper p {
    margin-bottom: 1rem;
    line-height: 1.4;
}
div.wrapper h1 {
    font-size: 3rem;
    font-weight: bold;
}
div.wrapper h2 {
    font-size: 2rem;
    font-weight: 100;
}
div.wrapper h3 {
    font-size: 1.4rem;
    font-weight: bold;
}
div.wrapper p {
    color: #454545;
}
div.wrapper label {
    color: #454545;
    margin-bottom: 0.2rem
}
div.wrapper blockquote {
    border-left: 0.3rem solid var(--v-background-darken4);
    background: var(--v-background-darken1);
    padding: 0.5rem 0.5rem 0.5rem 1rem;
    border-radius: 4px;
}
div.wrapper blockquote p:last-child {
    margin-bottom: 0;
}
div.wrapper ul {
    list-style: disc;
    padding-left: 2rem;
    margin-bottom: 1rem;
}
div.wrapper ol {
    padding-left: 2rem;
    margin-bottom: 1rem;
}
div.wrapper ul ul {
    list-style: disc;
}
div.wrapper ul ul, div.wrapper ol ol, div.wrapper ul li p:last-of-type, div.wrapper ol li p:last-of-type {
    margin-bottom: 0;
}
div.wrapper a {
    color: #454545;
    text-decoration: none;
}
div.wrapper a:after {
    content: ' (' attr(href) ') ';
    letter-spacing: 0;
}
${alertCss}
${checkboxCss}
${dynamicValueCss}
${inputCss}
`;

    let html = '';

    try {
        if (typeof content === 'string') {
            content = JSON.parse(content);
        }

        const editor = createEditor({ content });
        html = editor.getHTML();
    } catch (error) {
        html = `<p>${i18n.t('there_was_an_unexpected_error')} ${error.message}</p>`;
    }

    css = (css || defaultCss)
        .replace(/\/\*[\s\S]*?\*\//g, '$1')
        .replace(/\s*([{}|>;,])\s*/g, '$1')
        .replace(/\s+/g, ' ')
        .trim();

    return `<div class="wrapper">${html}</div><style type="text/css">${css}</style>`;
};

export const tipTapToText = (node, asArray = false) => {
    let lines = [];

    if (!node || !node.content) return asArray ? [] : '';

    node.content.forEach(n => {
        let nodeText = '';

        if (n.type === 'text' && n.text) {
            nodeText = n.text;
        }

        if (n.content) {
            nodeText += tipTapToText(n, asArray);
        }

        if (n.type === 'heading' || n.type === 'paragraph') {
            lines.push(nodeText);
        } else if (n.type === 'hardBreak') {
            lines.push('');
        } else {
            lines.push(nodeText);
        }
    });

    return asArray ? lines : lines.join('\n').trim();
};

export const toTipTap = text => {
    return {
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: text
                    }
                ]
            }
        ]
    };
};
